import * as React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography/Typography";
import PercentageNumber from "./PercentageNumber";
import CurrencyNumber from "./CurrencyNumber";

const styles = (theme) => ({
  spComparison: {
    textAlign: "center",
  },
  label: {
    [`@media only screen and ${theme.breakpoints.downNoMedia("md")}`]: {
      fontSize: 18,
      marginTop: "11%",
    },
  },
  value: {
    fontSize: 26,
    [`@media only screen and ${theme.breakpoints.downNoMedia("md")}`]: {
      fontSize: 24,
    },
    fontWeight: 500,
    padding: "10px 0",
    textAlign: "center",
    color: theme.palette.primary.main,
  },
  subscript: {
    fontSize: 16,
    fontWeight: 500,
    textAlign: "center",
    "-webkit-print-color-adjust": "exact", // PDF/Print styling
  },
});

const SpComparison = (props) => {
  const { classes, label, data, showSign, subscript } = props;
  return (
    <div className={classes.spComparison}>
      <Typography variant="h5" className={classes.label}>
        {label}
      </Typography>
      <Typography variant="h5" className={classes.value}>
        {data.type === "percentage" && (
          <PercentageNumber value={data.value} showSign={showSign} />
        )}
        {data.type === "currency" && (
          <CurrencyNumber value={data.value} showSign={showSign} />
        )}
      </Typography>
      <Typography variant="subtitle1" className={classes.subscript}>
        {subscript}
      </Typography>
    </div>
  );
};

SpComparison.propTypes = {
  classes: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  data: PropTypes.shape({
    value: PropTypes.number.isRequired,
    type: PropTypes.oneOf(["percentage", "currency"]),
  }).isRequired,
  showSign: PropTypes.bool,
  subscript: PropTypes.string,
};

SpComparison.defaultProps = {
  showSign: false,
  subscript: "vs. S&P 500",
};
export default withStyles(styles)(SpComparison);



// WEBPACK FOOTER //
// ./src/components/UI/SpComparison.jsx